module.exports = __webpack_public_path__ + "08_mole.8573efa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer2/08_mole.png
// module id = D+Lm
// module chunks = 0